import InputField from 'components/fields/InputField';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RiEyeCloseLine, RiEyeLine } from 'react-icons/ri';

const CreateAdmin = ({
  setAdminData,
  adminData,
  branches,
  setDisable,
  loadingBranch,
}) => {
  const [errors, setErrors] = useState([]);
  const [showPassword, setShowPassword] = useState(false); // State for password visibility
  const navigate = useNavigate();
  const [fieldErrors, setFieldErrors] = useState({});

  const capitalizeWords = (str) => {
    return str
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
  };

  const isValidPhone = (phone) => {
    const phoneRegex = /^[6-9]\d{9}$/; // Validates Indian phone numbers
    return phoneRegex.test(phone);
  };

  const handleInputChange = (event) => {
    const { id, value } = event.target;
    const formattedValue = id === 'adminName' ? capitalizeWords(value) : value;

    if (id === 'contactNumber' && !isValidPhone(value)) {
      setFieldErrors((prev) => ({
        ...prev,
        contactNumber:
          'Please enter a valid phone number (10 digits, starting with 6-9)',
      }));
    } else {
      setFieldErrors((prev) => ({
        ...prev,
        contactNumber: '',
      }));
    }

    setAdminData((prevData) => ({
      ...prevData,
      [id]: formattedValue,
    }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  useEffect(() => {
    const newErrors = [];
    if (
      !adminData.adminName.trim() ||
      !adminData.adminEmail.trim() ||
      !adminData.adminPassword.trim() ||
      !adminData.branchId.trim() ||
      !adminData.contactNumber.trim()
    ) {
      newErrors.push('Please fill in all fields.');
    }
    setErrors(newErrors);
    setDisable(newErrors.length > 0);
  }, [adminData, setDisable]);

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      {/* Header */}
      <h4 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
        Admin Information
      </h4>

      <div className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-2">
        <InputField
          extra="mb-3"
          label="Admin Name"
          placeholder="Enter Admin Name"
          id="adminName"
          type="text"
          onChange={handleInputChange}
          value={adminData?.adminName}
        />
        <InputField
          extra="mb-3"
          label="Admin Email"
          placeholder="Enter Admin Email"
          id="adminEmail"
          type="email"
          onChange={handleInputChange}
          value={adminData?.adminEmail}
        />
        <div>
          <InputField
            extra="mb-3"
            label="Admin Contact Number"
            placeholder="Enter Contact Number"
            id="contactNumber"
            type="text"
            maxLength={10}
            onChange={handleInputChange}
            value={adminData?.contactNumber}
          />
          {fieldErrors.contactNumber && (
            <div className="text-sm text-red-500">
              {fieldErrors.contactNumber}
            </div>
          )}
        </div>

        <div className="relative">
          <InputField
            extra="mb-3"
            label="Admin Password"
            placeholder="Enter Admin Password"
            id="adminPassword"
            type={showPassword ? 'text' : 'password'} // Toggle between text and password type
            onChange={handleInputChange}
            value={adminData?.adminPassword}
          />
          <button
            type="button"
            className="absolute right-4 top-2/3 -translate-y-1/2 transform text-lg text-navy-700 dark:text-white"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? <RiEyeLine /> : <RiEyeCloseLine />}
          </button>
        </div>
        <div>
          <label className="mb-3 ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Branch
          </label>
          <select
            onChange={(e) => {
              if (e.target.value === 'create') {
                navigate('/superadmin/branch/create');
              } else {
                handleInputChange(e);
              }
            }}
            id="branchId"
            value={adminData?.branchId}
            className="mb-1 mt-1.5 w-full rounded-xl border border-gray-200 py-3.5 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select</option>
            {loadingBranch ? (
              <option>Loading branches...</option>
            ) : branches.length === 0 ? (
              <option
                className="cursor-pointer font-bold text-brand-500"
                value="branchId"
              >
                No Branch available - Click to create
              </option>
            ) : (
              branches.map((branch, index) => (
                <option key={branch._id} value={branch._id}>
                  {index + 1} - {branch.name}({branch.location})
                </option>
              ))
            )}
          </select>
        </div>
      </div>
      {errors.length > 0 && (
        <div className="text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default CreateAdmin;
